import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import ModalAtis from "../../components/ModalAtis";
import { CardList, ContainerCard } from "../../styles-components/CardList";
import LoadingEffect from "../../components/LoadingEffect";
import { Container, ErrorMessage, Form, Row } from "./styles";
import { Container as ContainerForm } from "../../styles-components/Container";
import { Button, ButtonCreate } from "../../styles-components/Buttons";
import { apiHolidays } from "../../services/data";
import { toast } from "react-toastify";
import ItemCard from "../../components/ItemCard";
import { IoGridOutline } from "react-icons/io5";
import { FaRegListAlt } from "react-icons/fa";
import ItemColumnList from "../../components/ItemColumnList";

const ListHolidaysCalendar = () => {
  const [show, setShow] = useState(false);
  const [dateValue, setDateValue] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const { register, handleSubmit, setValue, formState: {errors} } = useForm({
    defaultValues: { description: "" },
  });
  const [isLoading, setIsLoading] = useState(true);
  const [holidays, setHolidays] = useState([]);
  const inputDate = useRef(null);
  const inputDescription = useRef(null);
  const [isDateInvalid, setIsDateInvalid] = useState(false);
  const [showButtonSubmit, setShowButton] = useState(false);
  const [dateExist, setDateExist] = useState(false);
  const [isRowStyle, setIsRowStyle] = useState(true);
  const [isEditing, setIsEditing] = useState(null);

  async function fetchDatas() {
    await apiHolidays.index().then((response) => {
      setHolidays(response.data.data);
    });
  }

  useEffect(() => {
    // setInterval(() => {
    //   teste();
    // }, 10000);
    fetchDatas();
    setIsLoading(false);
  }, []);

  const onSubmit = async (data) => {
    data.date = dateValue;
    try {
      if (!dateExist) {
        await apiHolidays.store(data);
        setIsLoading(true);
        setShow(false);
        toast.success("Feriado inserido com sucesso!", { autoClose: 2000 });
        fetchDatas();
        setIsLoading(false);
      } else {
        toast.error("Feriado já existe!");
      }
    } catch (e) {
      toast.error("Algo deu errado na inserção do feriado!");
    }
  };

  const onChangeDate = (date) => {
    setDateValue(date);
    setDateExist(holidays.some((element) => element.date === date));
    if (holidays.some((element) => element.date === date)) {
      setIsDateInvalid(true);
      setShowButton(false);
    } else {
      setIsDateInvalid(false);
      setShowButton(true);
    }
  };

  const onChangeDescription = (description) => {
    setDescriptionValue(description);
    if (descriptionValue === "") {
      setShowButton(false);
    } else {
      setShowButton(true);
    }
  };

  const handleOpenModal = () => {
    setDateValue("");
    setValue("description", "");
    setIsDateInvalid(false);
    setShow(true);
  };

  const onDelete = async (id) => {
    var confirmDelete = confirm(
      "Você tem certeza que deseja excluir este feriado?"
    );

    try {
      if (confirmDelete) {
        await apiHolidays.destroy(id);
        setIsLoading(true);
        toast.success("Feriado excluído com sucesso!", { autoClose: 2000 });
        fetchDatas();
        setIsLoading(false);
      }
    } catch (e) {
      console.log(e);
      toast.error("Algo deu errado na exclusão do feriado!");
    }
  };

  const handleShowFormEdit = async (id) => {
    try {
      var holiday = await apiHolidays.show(id);
      if (isEditing === id) {
        setIsEditing(null);
      } else {
        setDescriptionValue(holiday.data.data.description);
        setIsEditing(id);
        setShowButton(true);
      }
    } catch (e) {
      toast.error("Algo deu errado!");
    }
  };

  const onEdit = async (holiday, description) => {
    try {
      if (holiday.description === description) {
        toast.info("A descrição é a mesma! Nada foi alterado!", {
          autoClose: 2000,
        });
        setIsEditing(null);
      } else {
        var aux = await apiHolidays.update(holiday.id, {
          description: description,
        });
        setIsLoading(true);
        toast.success("Feriado editado com sucesso!", { autoClose: 2000 });
        setIsEditing(null);
        fetchDatas();
        setIsLoading(false);
      }
    } catch (e) {
      console.log(e);
      toast.error("Algo deu errado na edição do feriado!");
    }
  };

  const handleEnterPress = (e, holiday) => {
    if (e.charCode === 13) {
      e.preventDefault();
      onEdit(holiday, descriptionValue);
    }
  };

  return (
    <div>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <CardList>
          <header>
            <ButtonCreate color="--orange" onClick={() => handleOpenModal()}>
              Criar feriado
            </ButtonCreate>
            <Button
              hasEspecificMargin={"0px"}
              align="flex-end"
              color="--form-black"
              onClick={() => {
                setIsRowStyle((prev) => !prev);
              }}
            >
              {!isRowStyle ? (
                <IoGridOutline size={30} />
              ) : (
                <FaRegListAlt size={30} />
              )}
            </Button>
          </header>

          <ModalAtis onClose={() => setShow(false)} show={show}>
            <Container>
              <Form method="POST" onSubmit={handleSubmit(onSubmit)}>
                <Row hasError={isDateInvalid}>
                  <label>Data:</label>
                  <input
                    type="date"
                    value={dateValue}
                    onChange={(e) => onChangeDate(e.target.value)}
                    ref={inputDate}
                    required
                  />
                </Row>
                {isDateInvalid && (
                  <ErrorMessage>Este feriado já foi inserido</ErrorMessage>
                )}
                <Row>
                  <label>Descrição:</label>
                  <input
                    type="text"
                    {...register("description", { required: true })}
                  />
                </Row>
                {errors?.description && (
                  <ErrorMessage>A descrição é obrigatório</ErrorMessage>
                )}
                {showButtonSubmit && (
                  <Button
                    backgroundColor="--orange"
                    color="--white"
                    align="flex-end"
                  >
                    Cadastrar
                  </Button>
                )}
              </Form>
            </Container>
          </ModalAtis>

          {isRowStyle ? (
            <ContainerCard isRowStyle={isRowStyle}>
              {holidays.map((holiday) => (
                <div key={holiday.id}>
                  <ItemCard
                    date={holiday.date}
                    description={holiday.description}
                    isRowStyle={isRowStyle}
                    handleShowFormEdit={() => handleShowFormEdit(holiday.id)}
                    onDelete={() => onDelete(holiday.id)}
                  >
                    {isEditing === holiday.id && (
                      <Form>
                        <Row>
                          <label>Descrição:</label>
                          <input
                            type="text"
                            value={descriptionValue}
                            onChange={(e) =>
                              onChangeDescription(e.target.value)
                            }
                            ref={inputDescription}
                            onKeyPress={(e) => handleEnterPress(e, holiday)}
                          />
                        </Row>
                        {showButtonSubmit && (
                          <Button
                            backgroundColor="--orange"
                            color="--white"
                            align="flex-end"
                            type="button"
                            onClick={() => onEdit(holiday, descriptionValue)}
                          >
                            Salvar
                          </Button>
                        )}
                      </Form>
                    )}
                  </ItemCard>
                </div>
              ))}
            </ContainerCard>
          ) : (
            <>
              {holidays.map((holiday) => (
                <ItemColumnList
                  key={holiday.id}
                  date={holiday.date}
                  description={holiday.description}
                  isRowStyle={isRowStyle}
                  isEditing={isEditing}
                  handleShowFormEdit={() => handleShowFormEdit(holiday.id)}
                  onDelete={() => onDelete(holiday.id)}
                >
                  {isEditing === holiday.id && (
                    <Form>
                      <Row>
                        <label>Descrição:</label>
                        <input
                          type="text"
                          value={descriptionValue}
                          onChange={(e) => onChangeDescription(e.target.value)}
                          ref={inputDescription}
                          onKeyPress={(e) => handleEnterPress(e, holiday)}
                        />
                      </Row>
                      {showButtonSubmit && (
                        <Button
                          backgroundColor="--orange"
                          color="--white"
                          align="flex-end"
                          type="button"
                          onClick={() => onEdit(holiday, descriptionValue)}
                        >
                          Salvar
                        </Button>
                      )}
                    </Form>
                  )}
                </ItemColumnList>
              ))}
            </>
          )}
        </CardList>
      )}
    </div>
  );
};

export default ListHolidaysCalendar;
